import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Cómo recibo el Master Kit después de comprar?',
    a: 'Lo recibís por email una vez confirmado el pago. Es un material digital en PDF que podés descargar, guardar e imprimir.'
  }, {
    q: '¿Es un producto físico o digital?',
    a: 'Es un producto 100% digital. No se envía ningún producto físico.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. Podés imprimir las páginas que necesites y usarlas en casa, con tu familiar o con tus pacientes.'
  }, {
    q: '¿Necesito ser profesional de la salud para usarlo?',
    a: 'No. El material está explicado de forma clara para familiares y cuidadores. De todos modos, no reemplaza la consulta con profesionales de la salud.'
  }, {
    q: '¿Sirve si el adulto mayor tiene movilidad reducida?',
    a: 'El kit incluye actividades por niveles, incluyendo ejercicios suaves y opciones para realizar sentado. Siempre se recomienda consultar con un profesional antes de iniciar cualquier rutina física.'
  }, {
    q: '¿Qué medios de pago aceptan?',
    a: 'La compra se realiza mediante Mercado Pago. Allí podés ver los medios de pago disponibles para tu cuenta.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 30 días de garantía de satisfacción desde la compra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-63">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-64">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-65">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-2 md:space-y-4" data-id="element-66">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-cyan bg-familia-card' : 'border-familia-cyan/25 bg-familia-bg'}`} data-id="element-67">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-68">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-69">
                    {faq.q}
                  </span>
                  <span className={`text-familia-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-70">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-71">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-72">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-familia-gray text-[14px] sm:text-base leading-relaxed border-t border-white/10" data-id="element-73">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};